export type FixbotResourceType = 'product' | 'file' | 'guide' | 'wiki' | 'question';

interface FixbotEmbedUrlParams {
   /** Which FixBot to open, e.g. https://fixbot.ifixit.com. */
   origin: string;
   type: FixbotResourceType;
   /**
    * For a product: its handle, SKU, or product id; fixbot resolves any of
    * them. For a file: the document's documentid. Otherwise the record's id.
    */
   id: string | number;
   message?: string;
   /** True inside our iframe; FixBot then hides its own page chrome. */
   embedded?: boolean;
}

/**
 * fixbot reads `?type=&id=` (or `?questionid=` for a question) as the chat's
 * resource context and auto-sends `&message=` as the first message (fixbot
 * #2890). Embedded, a product sends `&product-page=1` and a file `&compact=1`,
 * which hide fixbot's own page chrome inside the iframe; a link that opens
 * FixBot as a page sends neither.
 */
export function buildFixbotEmbedUrl({
   origin,
   type,
   id,
   message,
   embedded = false,
}: FixbotEmbedUrlParams): string {
   const url = new URL(origin);
   if (type === 'question') {
      url.searchParams.set('questionid', String(id));
   } else {
      url.searchParams.set('type', type);
      url.searchParams.set('id', String(id));
   }
   if (embedded && type === 'product') {
      url.searchParams.set('product-page', '1');
   }
   if (embedded && type === 'file') {
      url.searchParams.set('compact', '1');
   }
   if (message) {
      url.searchParams.set('message', message);
   }
   return url.toString();
}
